<template>
  <StoreLocatorView />
</template>

<script>
import StoreLocatorView from "@/components/storeLocator/storeLocatorView.vue";

export default {
  components: {
    StoreLocatorView,
  },
};
</script>
